import styled from 'styled-components';
import { black, border1 } from '../../utils/style/colors';
import { ChangeEvent } from 'react';
import { useQuestionContext } from '../../context/chatbot/QuestionContextApi';
import { useTranslation } from 'react-i18next';

const StyledInput = styled.input`
  direction: ${(props) => props.theme.direction} !important;
  font-size: 1.1rem !important;
  font-weight: normal !important;
  height: 3.5rem !important;
  width: 100% !important;
  padding: 0.5rem 1rem 0.5rem 2rem !important;
  border: 1px solid ${black} !important;
  transition: all 1s ease !important;
  margin-top: 1rem !important;
  border-radius: 1rem !important;
  color: ${black} !important;
  box-sizing: border-box !important;

  &::placeholder {
    font-size: 1.1rem !important;
  }

  &:disabled {
    cursor: not-allowed !important;
    border: ${border1} !important;
  }

  &:focus {
    outline: none !important;
    box-shadow: none !important;
    border: 1px solid ${black} !important;
  }
`;

interface IProps {
  inputMessage: string;
  onInputMessage: (message: string) => void;
  ref?: React.LegacyRef<HTMLLabelElement>;
}

const Input: React.FC<IProps> = ({ onInputMessage, inputMessage, ref }) => {
  const { t } = useTranslation('chatbot');
  const questionContext = useQuestionContext();
  if (!questionContext) {
    throw new Error('There is no question context.');
  }
  const {
    question: { isLoading },
  } = questionContext;
  return (
    <label htmlFor="search-gpt" ref={ref}>
      <StyledInput
        className="outline-none rounded-lg"
        placeholder={t('inputMessage')}
        id="search-gpt"
        value={inputMessage}
        autoFocus={false}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          onInputMessage(e.target.value);
        }}
        disabled={isLoading}
      />
    </label>
  );
};

export default Input;
